import React from 'react';
import { ExtendedRouteObject } from '@/types';
import ROUTE_CONSTANTS from '@/routes/route-constants';

import { Accounts } from '@/routes/lazy-component-imports';

const AccountsRouteObject: ExtendedRouteObject[] = [
  {
    path: ROUTE_CONSTANTS.ACCOUNTS,
    element: <Accounts />,
    params: {
      title: 'Accounts',
      translationId: 'Portal.Accounts',
    },
  },
];
export default AccountsRouteObject;
